import React from 'react';

import Error from '../Error';

const Error404 = (props) => (
  <Error
    {...props}
    meta={{ title: '404: Not found' }}
    heading="Page not found"
    message="Sorry, but the page you were looking for could not be found."
  />
);
export default Error404;
